import {
  IServiceRequestsFilters,
  ITQActivityLogsQuery,
  ITQTagsQuery,
  ITQTopContributorsQuery,
} from '../types/tqConnectTypes/service-requests';
import {
  ITQProfileReviewsQuery,
  ITQShoutoutsQuery,
} from '../types/tqConnectTypes/user';

export const QUERY_KEYS = {
  // TQ Connect Config Query Keys
  TQ_CONNECT_CONFIG: ['TQ_CONNECT_CONFIG'],

  // TQ Connect User Profile Info Query Keys
  TQ_CONNECT_USER_PROFILE_INFO: (userId: string) => [
    'TQ_CONNECT_USER_PROFILE_INFO',
    userId,
  ],

  // TQ Connect Profile Completion Queries Query Keys
  TQ_CONNECT_PROFILE_COMPLETION_QUERIES: [
    'TQ_CONNECT_PROFILE_COMPLETION_QUERIES',
  ],

  // TQ Connect Service Requests Query Keys (Infinite)
  TQ_CONNECT_SERVICE_REQUESTS: (query: IServiceRequestsFilters) => [
    'TQ_CONNECT_SERVICE_REQUESTS',
    query,
  ],

  // TQ Connect Service Requests Statistics Query Keys
  TQ_CONNECT_SERVICE_REQUESTS_STATISTICS: [
    'TQ_CONNECT_SERVICE_REQUESTS_STATISTICS',
  ],

  // TQ Connect Single Service Request Query Keys
  TQ_CONNECT_SERVICE_REQUEST_BY_ID: (serviceRequestId: string) => [
    'TQ_CONNECT_SERVICE_REQUEST_BY_ID',
    serviceRequestId,
  ],

  // TQ Connect Service Request Chatroom Query Keys
  TQ_CONNECT_SERVICE_REQUEST_CHATROOM: (serviceRequestId: string) => [
    'TQ_CONNECT_SERVICE_REQUEST_CHATROOM',
    serviceRequestId,
  ],

  // TQ Connect Service Request Chatroom Message By ID Query Keys
  TQ_CONNECT_SERVICE_REQUEST_CHATROOM_MESSAGE_BY_ID: (
    serviceRequestId: string,
    roomId: string,
    messageId: string,
  ) => [
    'TQ_CONNECT_SERVICE_REQUEST_CHATROOM_MESSAGE_BY_ID',
    serviceRequestId,
    roomId,
    messageId,
  ],

  // TQ Connect Service Request Responses Query Keys (Infinite)
  TQ_CONNECT_SERVICE_REQUEST_RESPONSES: (
    serviceRequestId: string,
    limit: number,
  ) => ['TQ_CONNECT_SERVICE_REQUEST_RESPONSES', serviceRequestId, limit],

  // TQ Connect Service Request Response By ID Query Keys
  TQ_CONNECT_SERVICE_REQUEST_RESPONSE_BY_ID: (
    serviceRequestId: string,
    serviceRequestResponseId: string,
  ) => [
    'TQ_CONNECT_SERVICE_REQUEST_RESPONSE_BY_ID',
    serviceRequestId,
    serviceRequestResponseId,
  ],

  // TQ Connect Tags Query Keys
  TQ_CONNECT_TAGS: (query: ITQTagsQuery) => ['TQ_CONNECT_TAGS', query],

  // TQ Connect Activity Logs Query Keys (Infinite)
  TQ_CONNECT_ACTIVITY_LOGS: (query: ITQActivityLogsQuery) => [
    'TQ_CONNECT_ACTIVITY_LOGS',
    query,
  ],

  // TQ Connect Profile Reviews Query Keys (Infinite)
  TQ_CONNECT_PROFILE_REVIEWS: (query: ITQProfileReviewsQuery) => [
    'TQ_CONNECT_PROFILE_REVIEWS',
    query,
  ],

  // TQ Connect Leaderboard (Top Contributors) Query Keys
  TQ_CONNECT_TOP_CONTRIBUTORS: (query: ITQTopContributorsQuery) => [
    'TQ_CONNECT_TOP_CONTRIBUTORS',
    query,
  ],

  // TQ Connect Profile Shoutouts Query Keys (Infinite)
  TQ_CONNECT_PROFILE_SHOUTOUTS: (query: ITQShoutoutsQuery) => [
    'TQ_CONNECT_PROFILE_SHOUTOUTS',
    query,
  ],

  // Video Transcoding Job Details Query Keys
  VIDEO_TRANSCODING_JOB_DETAILS: (jobId: string) => [
    'VIDEO_TRANSCODING_JOB_DETAILS',
    jobId,
  ],
};
